import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { QuoteOutput, StudentDetails } from '@lx/quote-tool/shared/types/quote';
import { BehaviorSubject, Subscription } from 'rxjs';
import { StepService } from '@lx/quote-tool/shared/services/step-service';
import { MetaService } from '@lx/shared/seo';
import { MetaDefinition } from '@angular/platform-browser';
import { DepositService } from '@lx/quote-tool/shared/services';

@Component({
  selector: 'lx-enrolment-payment',
  templateUrl: './enrolment-payment.component.html',
  styleUrls: ['./enrolment-payment.component.scss'],
})
export class EnrolmentPaymentComponent implements OnInit, OnDestroy {
  studentDetails: Partial<StudentDetails>;
  quote: QuoteOutput;
  depositRequiredMessage: string;
  payNowButtonLabel = '';
  depositRequired = false;

  private isStepValid$ = new BehaviorSubject(true);
  private subscription = new Subscription();

  private readonly stepService = inject(StepService);
  private readonly metaService = inject(MetaService);
  private readonly depositService = inject(DepositService);

  constructor() {
    this.metaService.removeMetaTagOnRouteChange('robots');
  }

  ngOnInit(): void {
    const robots: MetaDefinition = { name: 'robots', content: 'noindex, nofollow' };
    this.metaService.addMetaTag(robots);
    this.stepService.setStepValid(this.isStepValid$);
    this.studentDetails = this.stepService.getStudentDetails();
    this.getActiveQuote();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  navigateToPaymentStep(): void {
    this.stepService.navigateToNextStep();
  }

  private getActiveQuote() {
    this.subscription.add(
      this.stepService.requestActiveQuote().subscribe((quoteOutput: QuoteOutput) => {
        this.quote = quoteOutput;
        const {
          payableData: { requiredThreshold, required },
        } = this.quote;
        this.depositRequired = required;
        this.payNowButtonLabel = this.depositRequired ? $localize`Pay now` : $localize`I wish to pay online`;
        if (required) {
          this.depositRequiredMessage = this.depositService.getDepositRequiredMessage(requiredThreshold);
        }
      }),
    );
  }
}
